/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryTender } from './EntryTender';
import {
    EntryTenderFromJSON,
    EntryTenderFromJSONTyped,
    EntryTenderToJSON,
    EntryTenderToJSONTyped,
} from './EntryTender';
import type { TokenEntryConfig } from './TokenEntryConfig';
import {
    TokenEntryConfigFromJSON,
    TokenEntryConfigFromJSONTyped,
    TokenEntryConfigToJSON,
    TokenEntryConfigToJSONTyped,
} from './TokenEntryConfig';
import type { CompetitionFeeStructure } from './CompetitionFeeStructure';
import {
    CompetitionFeeStructureFromJSON,
    CompetitionFeeStructureFromJSONTyped,
    CompetitionFeeStructureToJSON,
    CompetitionFeeStructureToJSONTyped,
} from './CompetitionFeeStructure';
import type { FuelPricingMode } from './FuelPricingMode';
import {
    FuelPricingModeFromJSON,
    FuelPricingModeFromJSONTyped,
    FuelPricingModeToJSON,
    FuelPricingModeToJSONTyped,
} from './FuelPricingMode';
import type { EscrowCurrency } from './EscrowCurrency';
import {
    EscrowCurrencyFromJSON,
    EscrowCurrencyFromJSONTyped,
    EscrowCurrencyToJSON,
    EscrowCurrencyToJSONTyped,
} from './EscrowCurrency';

/**
 * Entry fee configuration for paid competitions (REQUEST shape — used when creating/updating)
 * @export
 * @interface EntryFeeConfig
 */
export interface EntryFeeConfig {
    /**
     * Entry fee amount. REQUIRED whenever FUEL is a permitted tender; omit it on a token-gated competition, where one accepted token IS the entry cost and there is no Fuel price. The unit depends on which competition type owns the row, and the two do not agree. Challenges and tournaments store USD as cents (500 = $5.00) and FUEL as base units. Leaderboards store USD as whole dollars (1 = $1.00) and FUEL as base units. Read the owning type before doing arithmetic on this field. When fuelPricingMode is USD_EQUIVALENT the amount is denominated in USD even though feeCurrency is FUEL — the entrant pays FUEL converted at join time.
     * 
     * @type {number}
     * @memberof EntryFeeConfig
     */
    entryFee?: number;
    /**
     * Which tenders this competition accepts. Omit or send [FUEL] for a normal paid competition; [FUEL, TOKEN] to let a holder choose; [TOKEN] for a token-gated competition, which must omit entryFee.
     * 
     * @type {Array<EntryTender>}
     * @memberof EntryFeeConfig
     */
    permittedTenders?: Array<EntryTender>;
    /**
     * 
     * @type {TokenEntryConfig}
     * @memberof EntryFeeConfig
     */
    tokenEntryConfig?: TokenEntryConfig;
    /**
     * 
     * @type {EscrowCurrency}
     * @memberof EntryFeeConfig
     */
    feeCurrency?: EscrowCurrency;
    /**
     * Platform fee percentage (0-100)
     * @type {number}
     * @memberof EntryFeeConfig
     */
    platformFeePercent?: number;
    /**
     * 
     * @type {CompetitionFeeStructure}
     * @memberof EntryFeeConfig
     */
    feeStructure?: CompetitionFeeStructure;
    /**
     * 
     * @type {FuelPricingMode}
     * @memberof EntryFeeConfig
     */
    fuelPricingMode?: FuelPricingMode;
    /**
     * Optional minimum entry fee for variable-stake competitions
     * @type {number}
     * @memberof EntryFeeConfig
     */
    minEntryFee?: number;
    /**
     * Optional maximum entry fee for variable-stake competitions
     * @type {number}
     * @memberof EntryFeeConfig
     */
    maxEntryFee?: number;
}



/**
 * Check if a given object implements the EntryFeeConfig interface.
 */
export function instanceOfEntryFeeConfig(value: object): value is EntryFeeConfig {
    return true;
}

export function EntryFeeConfigFromJSON(json: any): EntryFeeConfig {
    return EntryFeeConfigFromJSONTyped(json, false);
}

export function EntryFeeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryFeeConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'permittedTenders': json['permittedTenders'] == null ? undefined : ((json['permittedTenders'] as Array<any>).map(EntryTenderFromJSON)),
        'tokenEntryConfig': json['tokenEntryConfig'] == null ? undefined : TokenEntryConfigFromJSON(json['tokenEntryConfig']),
        'feeCurrency': json['feeCurrency'] == null ? undefined : EscrowCurrencyFromJSON(json['feeCurrency']),
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'feeStructure': json['feeStructure'] == null ? undefined : CompetitionFeeStructureFromJSON(json['feeStructure']),
        'fuelPricingMode': json['fuelPricingMode'] == null ? undefined : FuelPricingModeFromJSON(json['fuelPricingMode']),
        'minEntryFee': json['minEntryFee'] == null ? undefined : json['minEntryFee'],
        'maxEntryFee': json['maxEntryFee'] == null ? undefined : json['maxEntryFee'],
    };
}

export function EntryFeeConfigToJSON(json: any): EntryFeeConfig {
    return EntryFeeConfigToJSONTyped(json, false);
}

export function EntryFeeConfigToJSONTyped(value?: EntryFeeConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryFee': value['entryFee'],
        'permittedTenders': value['permittedTenders'] == null ? undefined : ((value['permittedTenders'] as Array<any>).map(EntryTenderToJSON)),
        'tokenEntryConfig': TokenEntryConfigToJSON(value['tokenEntryConfig']),
        'feeCurrency': EscrowCurrencyToJSON(value['feeCurrency']),
        'platformFeePercent': value['platformFeePercent'],
        'feeStructure': CompetitionFeeStructureToJSON(value['feeStructure']),
        'fuelPricingMode': FuelPricingModeToJSON(value['fuelPricingMode']),
        'minEntryFee': value['minEntryFee'],
        'maxEntryFee': value['maxEntryFee'],
    };
}

